import { StatusPage } from "src/components/StatusPage/StatusPage";
import { TryAgainButton } from "src/components/StatusPage/StatusPageActions";

interface SignInFailedPageProps {
  /** Auth0's error message. */
  message: string | undefined;
  onTryAgain: () => void;
  /** Ends the Auth0 session, so the user can switch account. */
  onSignOut?: () => void;
}

/**
 * Shown when Auth0 reports a sign-in error, whether it lands on `/callback`
 * or on the app root. Props, not hooks, for the same reason as
 * AccessDeniedPage: auth renders this page.
 */
export function SignInFailedPage({ message, onTryAgain, onSignOut }: SignInFailedPageProps) {
  return (
    <StatusPage
      title="Sign-in failed"
      body={message}
      actions={<TryAgainButton onClick={onTryAgain} />}
      onSignOut={onSignOut}
    />
  );
}
